<template>
  <div class="vx-col w-full mb-base" ref="popupContainer">
    <vs-popup :active.sync="showSocietiesPopup" title="Sociétés rattachées au NDD">
      <vs-table :data="dnsSocieties" pagination :max-items="25" stripe auto-resize>
        <template slot="thead">
          <vs-th>Client</vs-th>
          <vs-th>N° Contrat</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(oneSociety, index) in data">
            <vs-td :data="oneSociety.society_id"><span>{{ oneSociety.name }}</span></vs-td>
            <vs-td :data="oneSociety.contract_id"><span>{{ oneSociety.contract_id ? oneSociety.contract_id : " " }}</span></vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <vs-popup :active.sync="showNetlinksPopup" title="Netlinks rattachés au NDD">
      <vs-table :data="dnsNetlinks" pagination :max-items="25" stripe auto-resize>
        <template slot="thead">
          <vs-th>Client</vs-th>
          <vs-th>N° Contrat</vs-th>
          <vs-th>Lien acheté</vs-th>
          <vs-th>Landing Page</vs-th>
          <vs-th>Type Ancre</vs-th>
          <vs-th>Type Lien</vs-th>
          <vs-th>Date Achat/Création</vs-th>
          <vs-th>Statut</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(oneNetlink, index) in data">
            <vs-td :data="oneNetlink.society_id"><span @click="displaySocietyPopup(getSocietyById(oneNetlink.society_id))" class="hvr-underline hvr-underline-out">{{ getSocietyName(oneNetlink.society_id) }}</span></vs-td>
            <vs-td :data="oneNetlink.contract_id"><span @click="displayContractPopup(oneNetlink.contract_id)" class="hvr-underline hvr-underline-out">{{ oneNetlink.contract_id ? oneNetlink.contract_id : " " }}</span></vs-td>
            <vs-td :data="oneNetlink.url_bought"><a class="hvr-underline hvr-underline-out" :href="oneNetlink.url_bought" target="_blank">{{ oneNetlink.url_bought }}</a></vs-td>
            <vs-td :data="oneNetlink.landing_page">
              <vx-tooltip :text="oneNetlink.landing_page"
                          position="top"
                          class="flex center">
                <vs-button color="primary"
                           size="large"
                           type="flat"
                           icon-pack="feather"
                           icon="icon-link-2"
                           :href="oneNetlink.landing_page"
                           target="_blank"></vs-button>
              </vx-tooltip>
            </vs-td>
            <vs-td :data="oneNetlink.anchor_type">{{ getNetlinkAnchorType(oneNetlink.anchor_type) }}</vs-td>
            <vs-td :data="oneNetlink.link_type">{{ getNetlinkLinkType(oneNetlink.link_type) }}</vs-td>
            <vs-td :data="oneNetlink.purchase_id"> {{ oneNetlink.creation_date ? getDateToFrenchFormat(oneNetlink.creation_date.substring(0,10)) : getDateToFrenchFormat(getPurchaseIdToPurchaseDate(oneNetlink.purchase_id)) }}</vs-td>
            <vs-td :data="oneNetlink.status">
              <vs-chip style="width: 80px"
                       :color="getNetlinkStatusColor(oneNetlink.status)"
                       class="ml-2">
                {{
              getNetlinkStatus(oneNetlink.status)
                }}
              </vs-chip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <vs-popup :active.sync="showDnsPopup" title="Modification d'un nom de domaine">
      <div class="vx-row center_div">
        <div class="vx-col sm:w-1/4 w-full mb-2">
		  	<label for="" class="vs-select--label">Statut</label>
			<div class="flex">
				<vs-select autocomplete
							v-model="modifiedDns.status"
							class="w-full select-medium mr-2"
							placeholder="Statut"
							:style="styleValidator('status')"
							@change="validateOne(modifiedDns.status, 'status')" >
					<vs-select-item :key="index"
									:value="item.value"
									:text="item.text"
									v-for="(item, index) in sAdminStatusOptions"
									class="w-full" />
				</vs-select>
				<vx-tooltip v-if="validators['status'] && validators['status'].errText !== ''" :text="errText('status')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Nom de domaine</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.host"
					:style="styleValidator('host')"
					@change="validateOne(modifiedDns.host, 'host')"
				/>
				<vx-tooltip v-if="validators['host'] && validators['host'].errText !== ''" :text="errText('host')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Port</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.port"
					:style="styleValidator('port')"
					@change="validateOne(modifiedDns.port, 'port')"
				/>
				<vx-tooltip v-if="validators['port'] && validators['port'].errText !== ''" :text="errText('port')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Login</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.login"
					:style="styleValidator('login')"
					@change="validateOne(modifiedDns.login, 'login')"
				/>
				<vx-tooltip v-if="validators['login'] && validators['login'].errText !== ''" :text="errText('login')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Mot de passe</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.pass"
					:style="styleValidator('pass')"
					@change="validateOne(modifiedDns.pass, 'pass')"
				/>
				<vx-tooltip v-if="validators['pass'] && validators['pass'].errText !== ''" :text="errText('pass')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Langue</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedDns.lang"
					class="w-full select-medium mr-2"
					:style="styleValidator('lang')"
					@change="validateOne(modifiedDns.lang, 'lang')"
				>
					<vs-select-item :key="index"
									:value="item.id.toString()"
									:text="item.name + ' (' + item.country + ')'"
									v-for="(item, index) in langList"
									class="w-full" />
				</vs-select>
				<vx-tooltip v-if="validators['lang'] && validators['lang'].errText !== ''" :text="errText('lang')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Domaine d'activité</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.domain_activity"
					:style="styleValidator('domain_activity')"
					@change="validateOne(modifiedDns.domain_activity, 'domain_activity')"
				/>
				<vx-tooltip v-if="validators['domain_activity'] && validators['domain_activity'].errText !== ''" :text="errText('domain_activity')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
          <label for="" class="vs-input--label">Date d'achat</label>
          <vx-input-group class="w-full bottom">
            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <span class="flex">
                  <vs-icon icon="calendar_today" size="small"></vs-icon>
                </span>
              </div>
            </template>
            <flat-pickr class="w-full"
                        v-model="modifiedDns.purchase_date"
                        :config="configEndDatePicker"
                        placeholder="Date d'achat"
                        :style="styleValidator('purchase_date')"
                        @input="validateOne(modifiedDns.purchase_date, 'purchase_date')"
            />
          </vx-input-group>
          <vx-tooltip v-if="validators['purchase_date'] && validators['purchase_date'].errText !== ''" :text="errText('purchase_date')" class="ml-3">
            <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
          </vx-tooltip>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Durée renouvellement (en mois)</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.before_renew_duration"
					:style="styleValidator('before_renew_duration')"
					@change="validateOne(modifiedDns.before_renew_duration, 'before_renew_duration')"
				/>
				<vx-tooltip v-if="validators['before_renew_duration'] && validators['before_renew_duration'].errText !== ''" :text="errText('before_renew_duration')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
          <vs-button color="primary" class="mt-2" @click="saveModifiedDns()">Modifier NDD</vs-button>
        </div>
      </div>
    </vs-popup>
	<FilterCard :refreshKey="1" :filters="filtersTemplates" :showListLength="displayedDns.length" @filter="handleFilterEmits($event)" :actions="actionsTemplates" @action="handleActionEmits($event)" :onChangeEmit="true" @clearAll="resetAllFilter()"/>

    <vx-card style="max-height:79vh; overflow: auto;">
      <div ref="netlinkTable" v-if="displayedDns.length > 0">
        <DnsTable :dns="displayedDns"
                  @delete-line="removeLine($event)"
                  @modify-dns="modifyDns($event)"
                  @display-societies="displayDnsSocieties($event)"
                  @display-netlinks="displayDnsNetlinks($event)" />
      </div>
    </vx-card>
  </div>
</template>

<script>
import DnsTable from "@/components/tables/DnsTable";
import Dns from "@/entities/Dns";
import store from "@/store/store";
import Validator from "@/entities/Validator";
import FilterCard from "@/views/filters/FilterCard";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import utilsMixin from "@/mixins/utilsMixin.js";
import VxTooltip from "../../components/widgets/vx-tooltip/VxTooltip.vue";

import XLSX from "xlsx";

export default {
	name: "DnsDashboard",
	components: {
		DnsTable,
		FilterCard,
		flatPickr,
		VxTooltip
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			langFilter: "",
			hostFilter: "",
			activeFilter: false,
			activityDomainFilter: "",
			statusFilter: [],
			langFilterOn: false,
			hostFilterOn: false,
			activeFilterOn: false,
			activityDomainFilterOn: false,
			statusFilterOn: false,
			// dns: [],
			displayedDnsFull: [],
			displayedDns: [],
			modifiedDns: new Dns(Dns.getFormFields()),
			showDnsPopup: false,
			showSocietiesPopup: false,
			showNetlinksPopup: false,
			dnsSocieties: [],
			dnsNetlinks: [],
			netlinkStatus: [
				{text: "Actif", value: 0},
				{text: "En\u00a0attente", value: 1},
				{text: "Refusé", value: 2},
				{text: "Terminé", value: 3},
				{text: "En\u00a0cours\u00a0de\u00a0rédaction", value: 4},
				{text: "Annulé", value: 5}
			],
			anchorTypes: [
				{text: "Brand et Générique", value: 0},
				{text: " Semi optimisée", value: 1},
				{text: "Générique", value: 2},
				{text: "Non optimisée", value: 3},
				{text: "Optimisée", value: 4},
			],
			linkTypes: [
			{text: "Lien HP", value: 0},
				{text: "Article Sponsorisé", value: 1},
				{text: "NDD expiré en redirection", value: 2},
				{text: "NDD expiré mini-site", value: 3},
				{text: "Lien Sponsorisé", value: 4},
				{text: "Forum", value: 5},
				{text: "Annuaire", value: 6},
				{text: "Article", value: 7},
				{text: "Média Référent", value: 11},
				{text: "RP digitale", value: 12},
			],
			langList: [
				{name: "Français", country: "France", id: 1},
				{name: "Anglais", country: "USA", id: 2},
				{name: "Anglais", country: "UK", id: 3},
				{name: "Chinois simplifié", country: "RPC", id: 4},
				{name: "Japonais", country: "Japon", id: 5},
				{name: "Coréen", country: "Corée du Sud", id: 6},
			],
			sAdminStatusOptions: [
				{text: "Actif", value: 1},
				/*
				 * { text: "A\u00a0Valider", value: 2 },
				 * { text: "En\u00a0pause", value: 3 },
				 */
				{text: "Terminé", value: 4},
				/*
				 * { text: "Annulé", value: 5 },
				 */
			],
			configEndDatePicker: {
				// minDate: new Date(),
				dateFormat: "j/n/Y"
			},
			validators: {},
			check: true,
			actionsTemplates: [{
				order: 1,
				emitSlugName: "new_NDD",
				buttonName: "Nouveau NDD",
				buttonIcon: "icon-plus-circle",
				buttonColor: "primary",
			}, {
				order: 2,
				emitSlugName: "action_extract_NDD",
				buttonName: "Exporter",
				buttonIcon: "icon-download-cloud",
				buttonColor: "dark",
			}, ],
			filtersTemplates: [
				{
					order: 1,
					emitSlugName: "filter_name",
					filterPlaceHolder: "Nom de domaine",
					value: "",
					type: "Input",
				}, {
					order: 2,
					emitSlugName: "filter_lang",
					filterPlaceHolder: "Langue",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [
							{name: "Français", country: "France", id: 1},
							{name: "Anglais", country: "USA", id: 2},
							{name: "Anglais", country: "UK", id: 3},
							{name: "Chinois simplifié", country: "RPC", id: 4},
							{name: "Japonais", country: "Japon", id: 5},
							{name: "Coréen", country: "Corée du Sud", id: 6},
						]
					}
				}, {
					order: 3,
					emitSlugName: "filter_domain",
					filterPlaceHolder: "Secteur d'activité",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: []
					}
				}, {
					order: 4,
					emitSlugName: "filter_status",
					filterPlaceHolder: "Statut (Sélection multiple)",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: true,
						dropdownValues: [
							{name: "Actif", id: 2},
							{name: "Terminé", id: 5}
						]
					}
				}]
		};
	},
	created() {
		/*
		 * this.getAllNetlink();
		 * this.getAllPurchases();
		 * this.getAllSociety();
		 */
		this.getAllDns();
		this.searchAndDisplay();
		this.filtersTemplates[2].params.dropdownValues = this.dnsActivityDomain;
	},
	mounted() {
		this.filtersTemplates[2].params.dropdownValues = this.dnsActivityDomain;
		this.displayedDnsFull = this.displayDns(this.dns);
	},
	watch: {
		dns: function(){
			//console.log("dns WATCH");
			this.displayedDns = [];
			this.displayedDnsFull = this.displayDns(this.dns);
			this.searchAndDisplay();
		},
		activityDomainFilter: function() {
			if(this.activityDomainFilter == "") {
				this.activityDomainFilterOn = false;
			}
			else{
				this.activityDomainFilterOn = true;
			}
			/*
			 * //console.log("activityDomainFilter")
			 *  this.displayedDns = this.filterDns(this.displayedDnsFull) //A CHANGER
			 */
			this.searchAndDisplay();
		},
		hostFilter: function() {
			if(this.hostFilter == "") {
				this.hostFilterOn = false;
			}
			else{
				this.hostFilterOn = true;
			}
			/*
			 * //console.log("societyFilter")
			 *  this.displayedDns = this.filterDns(this.displayedDnsFull) //A CHANGER
			 */
			this.searchAndDisplay();
		},
		activeFilter: function() {
			this.activeFilterOn = true;
			/*
			 * //console.log("activeFilter")
			 *  this.displayedDns = this.filterDns(this.displayedDnsFull) //A CHANGER
			 */
			this.searchAndDisplay();
		},
		langFilter: function() {
			if(this.langFilter == "") {
				this.langFilterOn = false;
			}
			else{
				this.langFilterOn = true;
			}
			/*
			 * //console.log("langFilter")
			 *  this.displayedDns = this.filterDns(this.displayedDnsFull) //A CHANGER
			 */
			this.searchAndDisplay();
		},
		statusFilter: function() {
			if(this.statusFilter == "") {
				this.statusFilterOn = false;
			}
			else{
				this.statusFilterOn = true;
			}
			// this.displayedContracts = this.filterContract(this.displayedContractsFull)
			this.searchAndDisplay();
		},
	},
	computed: {
		/*
		 * dns: () => {
		 *   return store.state.dns;
		 * },
		 * purchases: () => {
		 *   return store.state.purchases;
		 * },
		 */
		societies: () => {
			return store.state.societies;
		},
		providers: () => {
			return store.state.providers;
		},
		dns: () => {
			return store.state.dns;
		},
		dnsActivityDomain: () => {
			let dnsActivity = [];
			for(let row of store.state.dns){
				let foundDomainActivity = dnsActivity.findIndex(activityRow => activityRow.name == row.domain_activity);
				if(foundDomainActivity < 0){
					dnsActivity.push({name: row.domain_activity, id: row.domain_activity});
				}
			}
			return dnsActivity;
		}
	},
	methods: {
		// /**
		//  * Fetch all the purchases
		//  */
		// getAllPurchases() {
		//   ////console.log("getAllNetlink BEGIN")
		//   this.$store.dispatch("getAllPurchases");
		//   ////console.log("getAllNetlink END")
		// },

		// /**
		//  * Fetch all the dns
		//  */
		// getAllNetlink() {
		//   // //console.log("getAllNetlink BEGIN")
		//   this.$store.dispatch("getAllNetlink");
		//   // //console.log("getAllNetlink END")
		// },

		/**
		 * Fetch all the dns
		 */
		resetAllFilter(){
			this.langFilterOn = false;
			this.hostFilterOn = false;
			this.activeFilterOn = false;
			this.activityDomainFilterOn = false;
			this.statusFilterOn = false;
			this.searchAndDisplay();
		},
		getAllDns() {
			this.$store.dispatch("getAllDns");
		},

		/*
		 * getAllSociety() {
		 *     this.$store.dispatch("getAllSocieties");
		 * },
		 */

		getSocietyName(society_id){
			let society_name = "";
			let society = this.societies.find(society => society.id == society_id);
			society_name = society.name;
			return society_name;
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit){
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(row => row.emitSlugName == receivedEmit[0]);
			if(templateRowIndex >= 0) this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch(receivedEmit[0]){
			case"filter_name":
				this.hostFilter = receivedEmit[1].value;
				break;
			case"filter_lang":
				this.langFilter = receivedEmit[1].value;
				break;
			case"filter_status":
				this.statusFilter = receivedEmit[1].value;
				break;
			case"filter_domain":
				this.activityDomainFilter = receivedEmit[1].value;
				break;
			default:
				break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit){
			//console.log(receivedEmit);
			// Find template value
			switch(receivedEmit[0]){
			case"action_extract_NDD":
				this.exportData(this.dns);
				break;
			case"new_NDD":
				// <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })">Nouveau contrat</vs-button>
				this.$router.push({name: "new_entity", params: {newEntityForm: "dns", type: "DNS"}});
				break;
			default:
				break;
			}
		},

		removeLine(oneDns){
			let dnsToDelete = this.displayedDnsFull.find(element => element.id == oneDns.id);
			//console.log(dnsToDelete);
			this.displayedDnsFull = this.displayedDnsFull.filter(function(element){
				return element.id != oneDns.id;
			});
			this.displayedDns = this.displayedDnsFull;
			//console.log("removeLine");
		},

		modifyDns(dns){
			//console.log(dns);
			//Initialisation des données pour le popup
			this.modifiedDns = null; // Always reset data before assigning it
			let dnsData = JSON.parse(JSON.stringify(dns));
			this.modifiedDns = new Dns(dnsData);
			this.showDnsPopup = true;
		},

		/*
		 * ??????
		 * renewDns(dnsId){
		 *   this.$router.push({name: 'new_entity', params: { dnsId: dnsId, newEntityForm:'renewnetlink' } })
		 * },
		 */

		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet(){
			////console.log("isFilterSet BEGIN")
			if(this.langFilterOn || this.hostFilterOn || this.activityDomainFilterOn || this.statusFilterOn) return true;
			return false;
		},

		/**
		 * Return list of filtered dns A CHANGER
		 * @param {String} anchorFilterOn - Society is active?
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} linkFilterOn - Id of the commercial in charge of the project
		 * @return {List} - Societies' list filtered
		 */
		filterDns(dns){
			////console.log("filterProviders BEGIN")
			let dnsList = [];

			let searchKeyList = {};

			if(this.statusFilterOn){
				searchKeyList["statusFilter"] = this.statusFilter;
			}
			this.hostFilterOn ? searchKeyList["hostFilter"] = this.hostFilter.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : false;
			this.activityDomainFilterOn ? searchKeyList["activityDomainFilter"] = this.activityDomainFilter : false;
			this.langFilterOn ? searchKeyList["langFilter"] = this.langFilter : false;

			for(let dnsToFilter of dns){
				/*
				 * //console.log(dnsToFilter)
				 *  let society_name = this.getSocietyName(dnsToFilter.society_id)
				 */

				// if(society_name != "") society_name = society_name.toLowerCase()

				let dnsSearchKeyList = {};
				this.hostFilterOn ? dnsSearchKeyList["hostFilter"] = dnsToFilter.host.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : false;
				this.activityDomainFilterOn ? dnsSearchKeyList["activityDomainFilter"] = dnsToFilter.domain_activity : false;
				this.langFilterOn ? dnsSearchKeyList["langFilter"] = dnsToFilter.lang : false;
				this.statusFilterOn ? dnsSearchKeyList["statusFilter"] = dnsToFilter.status : false;

				let check = true;

				for(let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof dnsSearchKeyList[key])
					 */
					if(typeof searchKeyList[key] == "string"){
						if(typeof dnsSearchKeyList[key] == "string"){
							if(!dnsSearchKeyList[key].includes(searchKeyList[key])){
								check = false;
								break;
							}
						}
						else if(typeof dnsSearchKeyList[key] == "object"){
							////console.log("Array")
							let checkLoop = false;
							for(let value of dnsSearchKeyList[key]){
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if(service_name.includes(searchKeyList[key])){
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if(!checkLoop){
								check = checkLoop;
								break;
							}
						}
					}
					else{
						if(Array.isArray(dnsSearchKeyList[key])){
							// //console.log("dnsSearchKeyList[key]",dnsSearchKeyList[key])
							let searchKey = searchKeyList[key] - 1;
							// //console.log(searchKey)
							let stringSearchKey = searchKey.toString();
							if(!dnsSearchKeyList[key].includes(stringSearchKey)){
								check = false;
								break;
							}
						}
						else{
							if(Array.isArray(searchKeyList[key])){
								let searchKey = searchKeyList[key].map(value => value - 1);
								if(!searchKey.includes(dnsSearchKeyList[key])){
									check = false;
									break;
								}
							}
							else{
								let searchKey = searchKeyList[key] - 1;
								if(dnsSearchKeyList[key] != searchKey){
									check = false;
									break;
								}
							}
						}
					}
				}

				if(check) dnsList.push(dnsToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			return dnsList;
		},

		/**
		 * Return list of societies to display
		 * @return {List} - societies to display
		 */
		displayDns(dns){
			////console.log("displayDns BEGIN")
			let dnsList = [];
			if(this.displayedDns.length > 0){
				dnsList = this.displayedDns;
			}
			else{
				if(!this.isFilterSet()){
					dnsList = dns;
				}
			}
			return dnsList;
		},

		searchAndDisplay(){
			this.displayedDns = this.filterDns(this.displayedDnsFull); //A CHANGER
		},

		validateOne(val, name){
			let value = val;
			value === 0 ? value = "0" : "";
			let constname = "";
			if(name == "purchase_date"){
				constname = "dateConstraint";
				this.validators[name] = new Validator({constraintName: constname});
				if(this.modifiedDns.purchase_date == 0 || this.modifiedDns.purchase_date == null){
					this.validators[name].valid = false;
					this.validators[name].errText = "Ce champ ne peut être vide.";
					this.check = false;
				}
				else{
					this.validators["purchase_date"].errText = "";
					this.validators[name].valid = true;
				}
			}
			else{
				switch(name){
				case"host":
					constname = "domaineConstraint";
					break;
				case"login":
				case"pass":
				case"domain_activity":
					constname = "nameConstraint";
					break;
				default:
					value ? value = String(val) : "";
					value == null ? value = "" : "";
					constname = "isNumberConstraint";
					break;
				}
				this.validators[name] = new Validator({constraintName: constname});
				this.validators[name].check(value);
				val == null ? this.validators[name].valid == false : "";
				this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
				this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			}
			this.$forceUpdate();
		},
		errText(name){
			if(this.validators[name] && this.validators[name].errText !== ""){
				return this.validators[name].errText;
			}
		},
		styleValidator(name){
			if(this.validators && this.validators[name] && this.validators[name].valid == false && this.validators[name].errText !== ""){
				if(name == "purchase_date"){
					return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
				}
				else{
					return "border: 1px solid red !important; border-radius: 5px;";
				}
			}
			else if(this.validators && this.validators[name] && this.validators[name].errText == ""){
				if(name == "purchase_date"){
					return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
				}
				else{
					return "border: 1px solid green !important; border-radius: 5px;";
				}
			}
			else{
				return "border: none !important; border-radius: none;";
			}
		},

		saveModifiedDns(){
			this.check = true;
			let fields = ["host", "port", "login", "pass", "lang", "domain_activity", "before_renew_duration", "status"];
			let constname = "";

			for(let i = 0; i < fields.length; i++){
				let value = this.modifiedDns[fields[i]];
				value === 0 ? value = "0" : "";
				switch(fields[i]){
				case"host":
					constname = "domaineConstraint";
					break;
				case"login":
				case"pass":
				case"domain_activity":
					constname = "nameConstraint";
					break;
				default:
					value ? value = String(value) : "";
					value == null ? value = "" : "";
					constname = "isNumberConstraint";
					break;
				}

				this.validators[fields[i]] = new Validator({constraintName: constname});
				this.validators[fields[i]].check(value);
				this.modifiedDns[fields[i]] == null ? this.validators[fields[i]].valid = false : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == "" ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText !== "" ? this.check = false : "";
			}

			this.validators["purchase_date"] = new Validator({constraintName: "dateConstraint"});
			if(this.modifiedDns.purchase_date == 0 || this.modifiedDns.purchase_date == null){
				this.validators["purchase_date"].valid = false;
				this.validators["purchase_date"].errText = "Ce champ ne peut être vide.";
				this.check = false;
			}
			else{
				this.validators["purchase_date"].errText = "";
				this.validators["purchase_date"].valid = true;
			}
			this.$forceUpdate();

			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				let re = new RegExp("([T|Z])", "g");
				this.modifiedDns.purchase_date = this.modifiedDns.purchase_date.replace(re, " ").split("/").reverse().join("-");
				this.modifiedDns.renew_date = this.modifiedDns.purchase_date;
				//console.log("this.modifiedDns.purchase_date", this.modifiedDns.purchase_date);
				//console.log("this.modifiedDns.renew_date", this.modifiedDns.renew_date);
				/*
				 * this.modifiedDns.status = this.modifiedDns.status == true ? '1' : '0'
				 * let params = {
				 *   id: this.modifiedDns.id,
				 *   urlBought: this.modifiedDns.url_bought,
				 *   anchorType: this.modifiedDns.anchor_type,
				 *   landingPage: this.modifiedDns.landing_page,
				 *   status: this.modifiedDns.status,
				 *   linkType: this.modifiedDns.link_type,
				 *   domainAuthority: this.modifiedDns.domain_authority,
				 *   pageAuthority: this.modifiedDns.page_authority,
				 *   trustFlow: this.modifiedDns.trust_flow,
				 *   citationFlow: this.modifiedDns.citation_flow,
				 *   externalLinks: this.modifiedDns.external_links,
				 *   refDomains: this.modifiedDns.ref_domains,
				 *   purchase_id: this.modifiedDns.purchase_id,
				 *   society_id: this.modifiedDns.society_id,
				 *   creation_date: this.modifiedDns.creation_date,
				 *   recurring_purchase_id: this.modifiedDns.recurring_purchase_id,
				 * }
				 * //console.log("params")
				 * //console.log(params)
				 * let savedModifiedNetlink = new Netlink(params)
				 * //console.log(savedModifiedNetlink)
				 */
				this.modifiedDns.update((err, res) => {
					if(err) //console.log(err);
					if(res) {
						this.showDnsPopup = false;
						//console.log(res);
						this.getAllDns();
						//console.log(this.dns);
					}
				});
			}
		},

		displayDnsSocieties(dns_id){
			this.$http.get(this.apiUrl + "dns/gets/" + dns_id)
				.then(result => {
					this.dnsSocieties = result.data;
					this.showSocietiesPopup = true;
				})
				.catch(err => {
					//console.log(err);
				});
		},

		displayDnsNetlinks(dns_id){
			this.$http.get(this.apiUrl + "dns/getn/" + dns_id)
				.then(result => {
					this.dnsNetlinks = result.data;
					this.showNetlinksPopup = true;
				})
				.catch(err => {
					//console.log(err);
				});
		},

		exportData(dataIn){
			let data = JSON.parse(JSON.stringify(dataIn));

			for(let i = 0; i < data.length; i++){
				data[i]["status"] = this.getStatus(data[i]["status"]);
				data[i]["lang"] = this.getLang(data[i]["lang"]);
				data[i]["provider_id"] = this.research(data[i]["provider_id"], this.providers, "id", "society");
				data[i]["purchase_date"] = this.dateToFR(data[i]["purchase_date"]);
				data[i]["renew_date"] = this.dateToFR(data[i]["renew_date"]);

				for(let x in data[i]){
					data[i][x] = String(data[i][x]).trim();
				}

				this.$delete(data[i], "purchase_id");
				this.$delete(data[i], "before_renew_duration");
			}
			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "Netlink";

			let header = {
				header: [
					"id",
					"host",
					"login",
					"pass",
					"port",
					"domain_activity",
					"lang",
					"provider_id",
					"price",
					"purchase_date",
					"renew_date",
					"domain_authority",
					"referring_domains",
					"referring_links",
					"society_counter",
					"total_links",
					"status",
				],
				skipHeader: true,
				origin: -1
			};

			let header_names = [{
				id: "Identifiant",
				host: "Nom de domaine",
				login: "Login",
				pass: "Mot de passe",
				port: "Port",
				domain_activity: "Secteur d'activité",
				lang: "Langue",
				provider_id: "Prestataire",
				price: "Prix",
				purchase_date: "Date d'achat",
				renew_date: "Date de renouvellement",
				domain_authority: "Domain Authority",
				referring_domains: "Domaines référents",
				referring_links: "Liens entrants",
				society_counter: "Clients sur le NDD",
				total_links: "Liens totaux",
				status: "Statut",
			}];


			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Ndd_export.xls");
		},
	}
};
</script>
